// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "(max-width: 768px)";
var _5 = "(min-width: 1025px)";
var _6 = "flight-2KUdD";
var _7 = "inner-Bl1BS";
var _8 = "col-9gOTH";
var _9 = "col__head-KpFbX";
var _a = "col_sub-PVHb9";
var _b = "col_duration-EhR0M";
var _c = "col_time-1YKsg";
var _d = "fareGroup_stub-i7cW-";
var _e = "col_singleFare-3K2p4";
var _f = "date-2L6P2";
var _10 = "date_singleFare-ORhjv";
var _11 = "col_details-3Xt0I";
var _12 = "desktopFlightPopup_paper-1u1xq";
var _13 = "desktopFlight__headerTitle-15CbI";
var _14 = "desktopFlight__close-1o8sQ";
var _15 = "desktopFlight__closeIcon-w-xu4";
var _16 = "desktopFlight__button-tGcBg";
var _17 = "desktopFlight__buttonActive-1QAAb";
var _18 = "desktopFlight__compareFaresLink-4oyzf";
var _19 = "desktopFlight__compareFaresLinkIcon-38mgS";
var _1a = "desktopFlight__locationTerminal-aJXxE";
var _1b = "desktopFlight__locationTime-3EUuX";
var _1c = "desktopFlight__locationTimeIata-2iYcP";
var _1d = "slider__wrp-3UxDV";
var _1e = "slider__wrp_singleItem-1DfxX";
var _1f = "fareGroup__slide-1UFJp";
var _20 = "modalContent_paper-29vbV";
var _21 = "desktopFlight__scrollUp-3vwhR";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "tabletMiddle", _5 as "laptop", _6 as "flight", _7 as "inner", _8 as "col", _9 as "col__head", _a as "col_sub", _b as "col_duration", _c as "col_time", _d as "fareGroup_stub", _e as "col_singleFare", _f as "date", _10 as "date_singleFare", _11 as "col_details", _12 as "desktopFlightPopup_paper", _13 as "desktopFlight__headerTitle", _14 as "desktopFlight__close", _15 as "desktopFlight__closeIcon", _16 as "desktopFlight__button", _17 as "desktopFlight__buttonActive", _18 as "desktopFlight__compareFaresLink", _19 as "desktopFlight__compareFaresLinkIcon", _1a as "desktopFlight__locationTerminal", _1b as "desktopFlight__locationTime", _1c as "desktopFlight__locationTimeIata", _1d as "slider__wrp", _1e as "slider__wrp_singleItem", _1f as "fareGroup__slide", _20 as "modalContent_paper", _21 as "desktopFlight__scrollUp" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "tabletMiddle": _4, "laptop": _5, "flight": _6, "inner": _7, "col": _8, "col__head": _9, "col_sub": _a, "col_duration": _b, "col_time": _c, "fareGroup_stub": _d, "col_singleFare": _e, "date": _f, "date_singleFare": _10, "col_details": _11, "desktopFlightPopup_paper": _12, "desktopFlight__headerTitle": _13, "desktopFlight__close": _14, "desktopFlight__closeIcon": _15, "desktopFlight__button": _16, "desktopFlight__buttonActive": _17, "desktopFlight__compareFaresLink": _18, "desktopFlight__compareFaresLinkIcon": _19, "desktopFlight__locationTerminal": _1a, "desktopFlight__locationTime": _1b, "desktopFlight__locationTimeIata": _1c, "slider__wrp": _1d, "slider__wrp_singleItem": _1e, "fareGroup__slide": _1f, "modalContent_paper": _20, "desktopFlight__scrollUp": _21 }
